import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { load, save, confirm } from "actions/hdfActions";
import { getInitialValues } from "reducers/hdfReducer";
import { compose, lifecycle, withHandlers } from "recompose";
import { HDF_MAP, CLOSE_MESSAGE } from "./constants";

const enhance = compose(
  connect(
    ({ hdf: { employeeParticulars, fetching } }, { hdfId }) => {
      const initialValues = getInitialValues(employeeParticulars);
      return {
        initialValues,
        fetching,
        form: hdfId,
        data: employeeParticulars.byId,
      };
    },
    { load, save, confirm }
  ),
  lifecycle({
    componentDidMount() {
      const { load, hdfId, planYearId, enrolmentKey } = this.props;
      load(hdfId, planYearId, enrolmentKey);
    },
  }),
  withHandlers({
    onClose: ({ data: { CompletedOn } }) => evt => {
      evt.preventDefault();
      const isConfirmed = CompletedOn.fieldValue || window.confirm(CLOSE_MESSAGE);
      if (isConfirmed) {
        window.close();
      }
    },
    onPrint: () => () => {
      window.print();
    },
    onSave: ({ hdfId, save }) => () => {
      save(hdfId);
    },
  })
);

const FormData = ({ children, fetching, hdfId, ...props }) => {
  const HDFForm = HDF_MAP[hdfId];

  if (!HDFForm) {
    return <div>HDF Form not found.</div>;
  }

  return <HDFForm hdfId={hdfId} {...props} />;
};

FormData.propTypes = {
  hdfId: PropTypes.string.isRequired,
  children: PropTypes.func,
  fetching: PropTypes.bool,
};

export default enhance(FormData);



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/FormData.js